import React, { useState, useEffect } from "react";
import "../../css/Booking.css";
import { axiosAuth } from "../../utils/axiosInstance";

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const Booking = () => {
  const [bookings, setBookings] = useState([]);
  const [statusFilter, setStatusFilter] = useState("All");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosAuth.get("my-bookings");
        if (response.status === 200) {
          const reversedBookings = [...response.data.bookings].reverse();
          setBookings(reversedBookings);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const formatTime = (timeStr) => {
    const [hour, minute] = timeStr.split(":");
    const h = parseInt(hour);
    const suffix = h >= 12 ? "PM" : "AM";
    const formattedHour = h % 12 === 0 ? 12 : h % 12;
    return `${formattedHour}:${minute} ${suffix}`;
  };

  const handleCancel = async (bookingId) => {
    const confirmCancel = window.confirm(
      "Are you sure you want to cancel this booking?"
    );
    if (!confirmCancel) return;

    try {
      const response = await axiosAuth.get(`cancel-booking/${bookingId}`);
      if (response.status === 200) {
        setBookings((prev) =>
          prev.map((booking) =>
            booking.bookingId === bookingId
              ? { ...booking, status: "Cancelled" }
              : booking
          )
        );
        alert("Booking cancelled successfully.");
      } else {
        alert("Failed to cancel booking. Please try again later.");
      }
    } catch (error) {
      console.error(
        "Error cancelling booking:",
        error.response?.data || error.message
      );
      alert("Failed to cancel booking.");
    }
  };

  const filteredBookings = bookings.filter((booking) =>
    statusFilter === "All" ? true : booking.status === statusFilter
  );

  return (
    <section className="bookingSect">
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <h4 className="fw-bold">All-Bookings</h4>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-end align-items-center">
          <label className="me-2 fw-semibold">Filter by Status:</label>
          <select
            className="form-select w-auto"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="All">All</option>
            <option value="Pending">Pending</option>
            <option value="Success">Success</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>

        {filteredBookings.length > 0 ? (
          <table className="my-4 Booktable">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Name</th>
                <th>Facility</th>
                <th>Court</th>
                <th>Date</th>
                <th>Slot Timings</th>
                <th>Price</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredBookings.map((booking, index) => (
                <tr key={booking.bookingId}>
                  <td>{index + 1}</td>
                  <td>{booking.name || "N/A"}</td>
                  <td>{booking.facility}</td>
                  <td>{booking.court}</td>
                  <td>{booking.date}</td>
                  <td>
                    {booking.slots.length === 0 ? (
                      <div>00:00 - 00:00</div>
                    ) : (
                      booking.slots.map((slot, i) => (
                        <div key={i} style={{ marginBottom: "4px" }}>
                          <strong>Slot {i + 1}:</strong>{" "}
                          {formatTime(slot.start_time)} -{" "}
                          {formatTime(slot.end_time)}
                        </div>
                      ))
                    )}
                  </td>
                  <td>{booking.price}</td>
                  <td>{booking.status}</td>
                  <td>
                    {booking.status === "Success" ? (
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleCancel(booking.bookingId)}
                      >
                        Cancel
                      </button>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="mt-4">No bookings found.</p>
        )}
      </div>
    </section>
  );
};

export default Booking;
